import { Box } from "@mui/material";
import { AppCircularProgress } from "./Components/Progress/AppCircularProgress";
import { useExternalSSO } from "./Hooks/ExternalSSO";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { setIsRedirectingToSso } from "JS/Helpers/LocalStorageHelpers";

export const ExternalSSO = () => {
    const { resourceKey } = useParams() as any;
    const history = useHistory();
    const onError = () => history.goBack();
    const containerRef = useRef<HTMLDivElement>(null);
    const { loading, response } = useExternalSSO(resourceKey, onError);

    const [isReadyToSubmit, setIsReadyToSubmit] = useState(false);

    useEffect(() => {
        if (response) {
            setIsReadyToSubmit(true);
            if (containerRef?.current) {
                setIsRedirectingToSso("true");
                containerRef.current.innerHTML = response;
            }
        }
    }, [response]);

    useEffect(() => {
        if (isReadyToSubmit && containerRef.current) {
            const form = containerRef.current.getElementsByTagName("form")[0];
            if (form) form.submit();
        }
    }, [isReadyToSubmit]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            height="100dvh"
        >
            {loading && <AppCircularProgress />}
            <div ref={containerRef} />
        </Box>
    );
};
